export const navlink = [
    {
        name: "Home",
        link: "/",
        dropdown: false
    },
    {
        name: "Practices",
        link: "#", 
        dropdown: true,
        disableClick: true, 
        dropdownMenu: [
        "Criminal Law Cases",
  "Civil Law",
  "Real Estate & Property Law",
  "Motor Vehicles Act",
  "Consumer Protection Act",
  "Family Law & Matrimonial Disputes",
  "Negotiable Instruments Act",
  "Intellectual Property Rights (IPR)",
  "White Collar Crime",
  "Arbitration",
  "Commercial Law",
  "Insurance & Recovery Law",
  "Environmental Law",
  "Cyber Law",
  "Labour Law",
  "Education Law"
            
        ]
    },
    {
        name: "Article",
        link: "/blog",
        dropdown: false
    },
    {
        name: "Career",
        link: "/career", 
        dropdown: true,
        dropdownMenu: [
            "Internship",
            "Retainership"
        ]
    },
    {
        name: "About",
        link: "/about",
        dropdown: false
    },
    {
        name: "Contact",
        link: "/contact",
        dropdown: false
    },
];



export const meetingLink = "https://calendly.com/thedhyaniassociates/30min"